const RETELL_PROVIDER_UNAVAILABLE_CODES = new Set([
  'RETELL_PROVIDER_UNAVAILABLE',
  'RETELL_WORKSPACE_PROVIDER_UNAVAILABLE',
  'RETELL_PROVIDER_REQUEST_FAILED',
]);
const RETELL_WORKSPACE_SETUP_ERROR_PATTERNS = [
  /workspace config/i,
  /workspace not found/i,
  /provider profile/i,
  /api[_ -]?key.*not resolvable/i,
  /api[_ -]?key.*required/i,
  /retell api key/i,
];
const RETELL_WORKSPACE_SETUP_ERROR_CODES = new Set([
  'WORKSPACE_CONFIG_NOT_FOUND',
  'WORKSPACE_NOT_FOUND',
  'PROFILE_NOT_FOUND',
  'API_KEY_UNRESOLVABLE',
  'RETELL_API_KEY_MISSING',
]);

function getResponsePayload(error) {
  return error?.response?.data && typeof error.response.data === 'object'
    ? error.response.data
    : {};
}

export function isRetellProviderUnavailableError(error) {
  const payload = getResponsePayload(error);
  const code = String(payload.code || payload.error_code || payload.errorCode || '').trim();
  const status = Number(error?.response?.status || payload.status || 0);
  return RETELL_PROVIDER_UNAVAILABLE_CODES.has(code) || (status === 502 && code.startsWith('RETELL_'));
}

export function isRetellWorkspaceSetupError(error) {
  const payload = getResponsePayload(error);
  const status = Number(error?.response?.status || payload.status || 0);
  if (status !== 404 && status !== 409) return false;
  const code = String(payload.code || payload.error_code || payload.errorCode || '').trim();
  if (RETELL_WORKSPACE_SETUP_ERROR_CODES.has(code)) return true;
  const message = String(payload.error || payload.message || '').trim();
  if (!message) return false;
  return RETELL_WORKSPACE_SETUP_ERROR_PATTERNS.some((pattern) => pattern.test(message));
}

export function getRetellProviderErrorMessage(error, fallback) {
  const payload = getResponsePayload(error);
  if (isRetellProviderUnavailableError(error)) {
    const detail =
      payload.message ||
      payload.error ||
      'Retell is unavailable or rejected the provider request.';
    return `${detail} Check the Retell workspace/provider profile credentials, then retry.`;
  }
  return payload.error || payload.message || error?.message || fallback;
}
